/* Consent-gated website insights. Never reads customer fields or file contents. */
(function () {
  'use strict';
  var configNode = document.getElementById('tempo-clarity-config');
  if (!configNode || window.__tempoClarityInitialised) return;
  var config;
  try { config = JSON.parse(configNode.textContent); } catch (_) { return; }
  function state(value) { configNode.setAttribute('data-clarity-state', value); }
  if (!/^[a-z0-9]{5,32}$/i.test(config.projectId || '')) { state('invalid-project'); return; }
  if (config.designMode) { state('theme-editor'); return; }
  if (/^\/(?:account|checkouts?|challenge|cart|orders|apps)(?:\/|$)/i.test(location.pathname)) { state('excluded-page'); return; }
  if (document.querySelector('script[src*="clarity.ms/tag/"]')) { state('existing-tag'); return; }
  window.__tempoClarityInitialised = true;
  var requested = false;
  var privacyRequested = false;
  var previousConsent = null;
  var revoked = false;
  var sent = new WeakSet();
  function allowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    try { return !!(privacy && privacy.analyticsProcessingAllowed && privacy.analyticsProcessingAllowed()); }
    catch (_) { return false; }
  }
  function maskSensitive() {
    document.querySelectorAll('form, input, textarea, select, shopify-forms-embed, [data-tempo-photo-enquiry], [data-tempo-enquiry-context], .form-success, [data-tempo-upload-error]').forEach(function (node) {
      if (node.getAttribute('data-clarity-mask') !== 'true') node.setAttribute('data-clarity-mask', 'true');
    });
  }
  function consent(granted) {
    if (!requested || previousConsent === granted) return;
    previousConsent = granted;
    window.clarity('consentv2', { ad_Storage: 'denied', analytics_Storage: granted ? 'granted' : 'denied' });
    if (!granted) {
      // Denied storage alone permits cookie-less collection. Stop recording too.
      revoked = true;
      window.clarity('stop');
      state('consent-revoked');
    }
  }
  function load() {
    // Stay stopped until a new page load reads the visitor's latest choice.
    if (revoked) { state('consent-revoked'); return; }
    if (requested) { consent(true); return; }
    requested = true;
    window.clarity = window.clarity || function () { (window.clarity.q = window.clarity.q || []).push(arguments); };
    consent(true);
    window.clarity('set', 'view_mode', config.themeRole === 'main' ? 'live' : 'draft-review');
    var page = /^[a-z0-9_\-/]+$/i.test(location.pathname) ? location.pathname : '(other page)';
    window.clarity('set', 'page_path', page);
    var script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.clarity.ms/tag/' + config.projectId;
    script.setAttribute('data-tempo-clarity-tag', config.projectId);
    script.onload = function () {
      if (!allowed()) consent(false);
      // Covers withdrawal while the asynchronous tag was downloading.
      if (revoked) { window.clarity('stop'); state('consent-revoked'); }
      else state('loaded');
    };
    script.onerror = function () { state('load-error'); };
    state('loading');
    document.head.appendChild(script);
  }
  function successfulEnquiries() {
    if (revoked || !requested || !allowed()) return;
    document.querySelectorAll('[data-tempo-photo-enquiry][data-tracking-status="event-dispatched"], [data-tempo-enquiry-context][data-tracking-status="event-dispatched"]').forEach(function (node) {
      if (sent.has(node)) return;
      sent.add(node);
      window.clarity('event', 'enquiry_success');
    });
  }
  function start() {
    maskSensitive();
    var shopify = window.Shopify;
    if (shopify && !shopify.customerPrivacy && shopify.loadFeatures && !privacyRequested) {
      privacyRequested = true;
      try {
        shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], function (error) {
          if (!error) start(); else state('consent-api-error');
        });
      } catch (_) { state('consent-api-error'); }
    }
    if (allowed()) { load(); successfulEnquiries(); }
    else if (requested) consent(false);
    else state(shopify && shopify.customerPrivacy ? 'awaiting-consent' : 'awaiting-consent-api');
  }
  function ready() {
    start();
    if (document.body) new MutationObserver(function () { maskSensitive(); successfulEnquiries(); }).observe(document.body, {
      childList: true, subtree: true, attributes: true, attributeFilter: ['data-tracking-status']
    });
    var attempts = 0;
    var timer = window.setInterval(function () {
      start();
      if (++attempts >= 30 || (window.Shopify && window.Shopify.customerPrivacy)) window.clearInterval(timer);
    }, 1000);
  }
  document.addEventListener('visitorConsentCollected', start);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready); else ready();
}());
